import { useState } from 'react';
import { Box, MenuItem, TextField } from '@material-ui/core';
import { Trans } from '@lingui/macro';
import NgpCopyToClipboard from '../../form/NgpCopyToClipboard';
import { usePortalLocation } from '../../../stores/EnvironmentStore';
import {
    AGENT_HOST_HTTP_CLIENT_CURL,
    AGENT_HOST_HTTP_CLIENT_WGET,
    AGENT_OS_DOCKER_MAC,
    AGENT_OS_MAC,
    AGENT_VIRTUAL_290_MODEL,
    AGENT_VIRTUAL_2K_MODEL,
    AGENT_VIRTUAL_3K_MODEL,
} from './AgentConstants';

const httpsRegex = /https/;
const fieldLabel = 'Linux HTTP client';
const curlOptionText = 'curl is installed (CentOS)';
const wgetOptionText = 'wget is installed (Ubuntu)';
const modelParam2k = '2000';
const modelParam3k = '3000';
const modelParam290 = '290';

function buildLinuxCurlInstructions(theXmsLocation, portalLocation, model) {
    const modelParam = getModelParam(model);
    const secureParam = httpsRegex.test(portalLocation) ? '-klg' : '-lg';

    return `sudo su -c "bash <(curl ${secureParam} ${portalLocation}/install) ${theXmsLocation} ${modelParam}"`;
}

function buildLinuxWgetInstructions(theXmsLocation, portalLocation, model) {
    const modelParam = getModelParam(model);
    const secureParam = httpsRegex.test(portalLocation) ? '--no-check-certificate ' : '';

    return `sudo su -c "bash <(wget -q ${secureParam}-O- ${portalLocation}/install) ${theXmsLocation} ${modelParam}"`;
}

function buildMacCurlInstructions(theXmsLocation, portalLocation, model) {
    const modelParam = getModelParam(model);
    const secureParam = httpsRegex.test(portalLocation) ? '-klg' : '-lg';

    return `bash <(curl ${secureParam} ${portalLocation}/install-docker) ${theXmsLocation} ${modelParam}`;
}

function buildMacNativeCurlInstructions(theXmsLocation, portalLocation, model) {
    const modelParam = getModelParam(model);
    const secureParam = httpsRegex.test(portalLocation) ? '-k' : '';

    return `sudo bash -c "$(curl ${secureParam} ${portalLocation}/install-mac-native)" _ ${theXmsLocation} ${modelParam}`;
}

function getModelParam(model) {
    let modelParam;
    switch (model) {
        case AGENT_VIRTUAL_2K_MODEL:
            modelParam = modelParam2k;
            break;
        case AGENT_VIRTUAL_3K_MODEL:
            modelParam = modelParam3k;
            break;
        case AGENT_VIRTUAL_290_MODEL:
            modelParam = modelParam290;
            break;
        default:
            modelParam = modelParam290;
            break;
    }
    return modelParam;
}

/** @param {import('./AgentDownloadDialog').WizardProps} props */
export default function AgentDownloadInstallLinux({ wizardSelections, primaryXmsLocation }) {
    const { httpClient, os } = wizardSelections.current;

    const [portalLocation] = usePortalLocation();
    const [distroSelection, setDistroSelection] = useState(httpClient);

    const handleChange = (e) => {
        const theDistroSelection = e.target.value;
        wizardSelections.current.httpClient = theDistroSelection;
        setDistroSelection(theDistroSelection);
    };

    let installCmd;

    if (os === AGENT_OS_DOCKER_MAC) {
        installCmd = buildMacCurlInstructions(primaryXmsLocation, portalLocation, wizardSelections.current.model);
    } else if (os === AGENT_OS_MAC) {
        installCmd = buildMacNativeCurlInstructions(primaryXmsLocation, portalLocation, wizardSelections.current.model);
    } else {
        installCmd =
            distroSelection === AGENT_HOST_HTTP_CLIENT_CURL
                ? buildLinuxCurlInstructions(primaryXmsLocation, portalLocation, wizardSelections.current.model)
                : buildLinuxWgetInstructions(primaryXmsLocation, portalLocation, wizardSelections.current.model);
    }

    return (
        <>
            {os !== AGENT_OS_DOCKER_MAC && os !== AGENT_OS_MAC && (
                <TextField select label={fieldLabel} value={distroSelection} onChange={handleChange}>
                    <MenuItem value={AGENT_HOST_HTTP_CLIENT_CURL}>{curlOptionText}</MenuItem>
                    <MenuItem value={AGENT_HOST_HTTP_CLIENT_WGET}>{wgetOptionText}</MenuItem>
                </TextField>
            )}

            <Box mt={2} mb={2}>
                <Trans>Enter the following command in a terminal to install the nPoint software</Trans>
                <Box mb={1.5} />
                <NgpCopyToClipboard multiline value={installCmd} rows={1} rowsMax={1} inputProps={{ cols: 100 }} />
            </Box>
        </>
    );
}
